import { z } from 'zod/v4';

/** Unmasked original DSM fit. Review thresholds are heuristics, not survey certification. */
export const solarPlaneFitSchema = z.object({
  status: z.enum(['usable', 'review', 'unavailable']),
  sampleCount: z.number().int().nonnegative(),
  eligiblePixelCount: z.number().int().nonnegative(),
  outsidePixelCount: z.number().int().nonnegative(),
  rmsMetres: z.number().nullable(),
  coverage: z.number().nullable(),
  reasons: z.array(z.string()),
  confidence: z.enum(['clear', 'tentative']),
  note: z.string(),
});
export type SolarPlaneFit = z.infer<typeof solarPlaneFitSchema>;

/** False when the fit measured no angles, so pitch and bearing are placeholders. */
export const hasMeasuredPlane = (face: {
  planeFit?: { status: SolarPlaneFit['status'] } | null;
}): boolean => face.planeFit?.status !== 'unavailable';

export type SolarPlaneFitInput = Omit<
  SolarPlaneFit,
  'rmsMetres' | 'coverage'
> & {
  rmsMetres?: number | null;
  coverage?: number | null;
};

export const normaliseSolarPlaneFit = (
  planeFit: SolarPlaneFitInput | null | undefined
): SolarPlaneFit | undefined =>
  planeFit
    ? {
        ...planeFit,
        rmsMetres: planeFit.rmsMetres ?? null,
        coverage: planeFit.coverage ?? null,
      }
    : undefined;
